var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyledComponentsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 297,
    height: 121,
    viewBox: "0 0 297 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "styled-components-logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 70",
    d: "M163.107 89.147C163.476 85.2182 183.8 73.2785 188.973 70.8372C190.434 74.4428 184.307 77.5977 181.366 79.0062C188.182 79.0062 193.943 75.7198 195.972 74.2174C192.624 87.7386 178.322 97.0343 173.758 98.1611C165.557 100.186 162.499 95.6259 163.107 89.147Z",
    fill: "url(#paint0_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 64",
    d: "M6.1875 75.3442V65.4851L55.4846 37.316L60.3535 43.5132L13.7951 70.2738L60.3535 98.4428L55.4846 103.795L6.1875 75.3442Z",
    fill: "url(#paint1_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 65",
    d: "M240.907 36.1893L236.951 41.8231L283.205 69.147L236.951 96.7526L241.82 102.386L290.812 73.9357V64.3583L240.907 36.1893Z",
    fill: "url(#paint2_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 66",
    d: "M221.533 0.978012H198.71L196.276 15.6259C198.666 18.7073 201.799 20.7015 205.101 21.9434C211.216 24.2435 217.91 23.9632 221.533 23.2315V0.978012Z",
    fill: "url(#paint3_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.323 120.978C180.147 113.372 195.971 95.9076 189.276 87.1752C186.842 90.5555 178.93 99.0062 169.192 99.0062C166.493 99.0062 161.858 96.543 163.051 88.3793L162.498 89.1471L124.46 120.978H171.323ZM123.547 120.978H123.243H91.8994L92.0237 113.372L92.0421 112.246L91.8994 83.7949L131.155 52.2456C131.56 52.1517 132.25 52.1329 131.763 52.809C125.981 57.5977 124.079 60.6963 124.764 63.2315C125.449 65.7667 131.2 70.2072 136.023 68.5836C139.371 67.4569 146.065 64.0766 151.543 57.5977C152.257 56.7527 155.033 56.471 153.511 62.1048C153.49 62.184 153.47 62.3129 153.463 62.4522L153.369 62.1048L92.2038 111.964V113.091L153.673 63.2316L153.638 63.1003C153.696 63.1205 153.772 63.1047 153.87 63.0375L153.977 62.9498L155.194 62.1048C155.803 61.8231 155.742 62.1611 155.499 62.3865C155.309 62.5618 155.097 62.7492 154.871 62.9491C152.914 64.6762 149.906 67.3318 151.543 71.1188C152.517 73.3724 156.581 77.4523 161.281 76.1893C164.932 75.2079 172.175 71.8512 178.017 64.64C178.474 64.0766 179.726 63.5132 180.147 66.0484C180.545 68.4411 180.614 73.5969 178.322 75.3442C177.829 75.7195 177.295 76.1255 176.731 76.554C171.368 80.6279 163.317 86.7444 163.106 88.0198V87.7386L123.547 120.696V120.978Z",
    fill: "url(#paint4_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 68",
    d: "M125.069 62.1048C125.613 55.0625 147.589 41.5414 152.762 39.0062C155.805 37.515 160.978 39.8512 159.456 44.0766C154.182 58.7245 141.806 66.8937 135.112 68.5836C132.068 69.3521 124.765 66.0484 125.069 62.1048Z",
    fill: "url(#paint5_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 69",
    d: "M151.238 68.8653C151.776 62.3864 173.148 49.9921 179.538 45.9363C182.581 44.4451 187.901 46.9409 186.233 51.1188C180.451 65.5972 168.28 73.9358 161.307 75.9076C156.682 77.2157 150.933 72.5273 151.238 68.8653Z",
    fill: "url(#paint6_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 72",
    d: "M213.012 23.5132C207.9 23.0625 206.014 22.1048 205.101 21.8231L195.059 57.5977L202.666 56.1893L213.012 23.5132Z",
    fill: "url(#paint7_linear_35_248)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 73",
    d: "M182.582 78.7245C199.014 78.1611 203.615 63.5155 202.666 56.1893L195.386 57.5803C191.517 58.6932 189.656 66.9387 189.277 70.5555C190.415 74.5617 185.427 77.0552 182.582 78.7245Z",
    fill: "url(#paint8_linear_35_248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_35_248",
    x1: 189.277,
    y1: 72.5273,
    x2: 169.639,
    y2: 98.5214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_35_248",
    x1: 63.7008,
    y1: 42.1048,
    x2: 21.4396,
    y2: 89.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_35_248",
    x1: 282.292,
    y1: 41.5414,
    x2: 245.706,
    y2: 99.9413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_35_248",
    x1: 205.101,
    y1: 20.1329,
    x2: 217.269,
    y2: 4.00054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_35_248",
    x1: 171.627,
    y1: 53.0907,
    x2: 119.658,
    y2: 113.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_35_248",
    x1: 153.977,
    y1: 41.5414,
    x2: 132.515,
    y2: 67.1359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_35_248",
    x1: 178.433,
    y1: 48.429,
    x2: 155.108,
    y2: 74.8915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_35_248",
    x1: 211.795,
    y1: 20.6963,
    x2: 194.767,
    y2: 66.3969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#056945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01A66B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_35_248",
    x1: 201.646,
    y1: 53.4071,
    x2: 192.311,
    y2: 71.9401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A66B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#056945"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyledComponentsLogo);
export default __webpack_public_path__ + "static/media/styled-components-logo.f0d5bcae7408248f7a88b800fa3468ae.svg";
export { ForwardRef as ReactComponent };